import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

const featuredEpisodes = [
  { id: "42u_fgtZWzE", title: "Dominik Mysterio y WWE 2K", titleEn: "Dominik Mysterio and WWE 2K" },
  { id: "IynmdYtjej0", title: "Apex Legends", titleEn: "Apex Legends" },
  { id: "T4yjb2MLdqE", title: "Guilty Gear", titleEn: "Guilty Gear" },
];

const photoStrip = [
  { src: "/show-fotos/show-strip-1.jpg", altEs: "Talento de Puerto Rico Esports League: The Show", altEn: "Talent from Puerto Rico Esports League: The Show", objectPosition: "center 34%" },
  { src: "/show-fotos/show-strip-2.jpg", altEs: "Producción de Puerto Rico Esports League: The Show", altEn: "Production from Puerto Rico Esports League: The Show", objectPosition: "center center" },
  { src: "/show-fotos/show-strip-3.jpg", altEs: "Escena del set de Puerto Rico Esports League: The Show", altEn: "Set scene from Puerto Rico Esports League: The Show", objectPosition: "center 38%" },
  { src: "/show-fotos/show-strip-4.jpg", altEs: "Momento en cámara de Puerto Rico Esports League: The Show", altEn: "On-camera moment from Puerto Rico Esports League: The Show", objectPosition: "center 30%" },
  { src: "/show-fotos/show-strip-5.jpg", altEs: "Escenografía de Puerto Rico Esports League: The Show", altEn: "Set design from Puerto Rico Esports League: The Show", objectPosition: "center 6%" },
];

const copyByLang = {
  es: {
    title: "El Show | Puerto Rico Esports League",
    description: "Descubre El Show de Puerto Rico Esports League, el formato audiovisual principal de PREL construido alrededor de esports, entretenimiento, eventos en vivo y contenido original.",
    ogDescription: "El programa principal de PREL combina esports, entretenimiento, narrativa original e industria gaming para televisión y plataformas digitales.",
    schemaDescription: "Programa insignia de PREL construido alrededor de esports, entretenimiento, contenido original, cobertura de eventos y cruces con industria gaming.",
    heroEyebrow: "Propiedad principal de PREL",
    heroTitle: "Puerto Rico Esports League:",
    heroHighlight: "El Show",
    heroBody:
      "El programa principal de PREL es un formato de gaming y entretenimiento nacido en Puerto Rico que mezcla esports, cultura pop, cobertura de eventos, invitados y contenido original. Diseñado para televisión y distribución digital, es uno de los activos más fuertes de PREL como plataforma con potencial de crecimiento más allá del mercado local.",
    metrics: [
      ["48", "Episodios producidos"],
      ["~10", "Puntos de rating por programa"],
      ["TV local + digital", "Contexto de distribución"],
    ],
    metricsNote:
      "El programa se transmite a través de un canal local de televisión en Puerto Rico y ha alcanzado resultados cercanos a 10 puntos de rating por programa, un desempeño relevante para un formato independiente de gaming y esports construido en la isla.",
    partnerEyebrow: "Broadcast & Distribution Partners",
    partnerTitle: "En colaboración con WIPR y disponible también a través de PRTV+.",
    partnerBody:
      "El Show extiende su presencia entre televisión pública local y distribución digital, reforzando su alcance como propiedad mediática de gaming y entretenimiento nacida en Puerto Rico.",
    whyEyebrow: "Por qué importa",
    whyTitle: "Más que un programa local",
    whyBody1:
      "Lo importante de El Show no es solo su audiencia, sino el formato que ha logrado construir. PREL desarrolló una propiedad mediática repetible: un espacio para contenido, invitados, narrativa de marca y cruces entre gaming y entretenimiento.",
    whyBody2:
      "A medida que gaming, entretenimiento deportivo, creator media y formatos juveniles siguen mezclándose, El Show le da a PREL una base más fuerte para conversaciones de distribución, alianzas, amplificación y crecimiento.",
    highlights: [
      {
        title: "Formato televisivo con ADN gaming",
        body: "El programa principal de PREL mezcla esports, cultura gaming, entrevistas, cobertura de eventos y entretenimiento en un formato pensado para televisión y distribución digital.",
      },
      {
        title: "Nace en Puerto Rico, pero conversa más allá",
        body: "Aunque nace en Puerto Rico, el formato del show tiene energía y lenguaje suficiente para conectar con audiencias más amplias en el mercado hispano, Latinoamérica y espacios crossover ligados al gaming.",
      },
      {
        title: "Un espacio para talento, marcas y momentos",
        body: "El show abre espacio para invitados, integraciones de marca, recaps de eventos, talento local y momentos que conectan gaming con entretenimiento y cultura popular.",
      },
    ],
    samplesEyebrow: "Muestras seleccionadas",
    samplesTitle: "Ver El Show",
    visitWipr: "Visitar WIPR",
  },
  en: {
    title: "The Show | Puerto Rico Esports League",
    description: "Discover Puerto Rico Esports League: The Show, PREL's flagship audiovisual format built around esports, entertainment, live events, and original content.",
    ogDescription: "PREL's flagship show blends esports, entertainment, original storytelling, and gaming industry relevance for television and digital platforms.",
    schemaDescription: "PREL's flagship program built around esports, entertainment, original content, event coverage, and gaming-industry crossovers.",
    heroEyebrow: "PREL flagship property",
    heroTitle: "Puerto Rico Esports League:",
    heroHighlight: "The Show",
    heroBody:
      "PREL's flagship show is a gaming and entertainment format born in Puerto Rico that blends esports, pop culture, event coverage, guests, and original content. Designed for television and digital distribution, it is one of PREL's strongest assets as a platform with growth potential beyond the local market.",
    metrics: [
      ["48", "Episodes produced"],
      ["~10", "TV rating points per episode"],
      ["Local TV + digital", "Distribution context"],
    ],
    metricsNote:
      "The show airs through a local television channel in Puerto Rico and has reached results near 10 rating points per episode, a meaningful performance for an independent gaming and esports format built on the island.",
    partnerEyebrow: "Broadcast & distribution partners",
    partnerTitle: "In partnership with WIPR and also available through PRTV+.",
    partnerBody:
      "The Show extends its presence across local public television and digital distribution, reinforcing its reach as a gaming and entertainment media property born in Puerto Rico.",
    whyEyebrow: "Why it matters",
    whyTitle: "More than a local show",
    whyBody1:
      "What matters about The Show is not just its audience, but the format it has built. PREL developed a repeatable media property: a space for content, guests, brand storytelling, and crossovers between gaming and entertainment.",
    whyBody2:
      "As gaming, sports entertainment, creator media, and youth-oriented formats keep blending together, The Show gives PREL a stronger base for distribution, partnership, amplification, and growth conversations.",
    highlights: [
      {
        title: "A TV format with gaming DNA",
        body: "PREL's flagship program mixes esports, gaming culture, interviews, event coverage, and entertainment in a format built for television and digital distribution.",
      },
      {
        title: "Born in Puerto Rico, built to travel",
        body: "While it comes from Puerto Rico, the format has the energy and language to connect with broader audiences across the U.S. Hispanic market, Latin America, and gaming-adjacent crossover spaces.",
      },
      {
        title: "A place for talent, brands, and moments",
        body: "The show creates room for guests, brand integrations, event recaps, local talent, and moments that connect gaming with entertainment and pop culture.",
      },
    ],
    samplesEyebrow: "Selected samples",
    samplesTitle: "Watch The Show",
    visitWipr: "Visit WIPR",
  },
};

export default function ShowPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language === "en" ? "en" : "es";
  const copy = copyByLang[lang];

  useEffect(() => {
    document.title = copy.title;

    const setMeta = (name, content, isProperty = false) => {
      const selector = isProperty ? `meta[property='${name}']` : `meta[name='${name}']`;
      let tag = document.head.querySelector(selector);
      if (!tag) {
        tag = document.createElement("meta");
        if (isProperty) tag.setAttribute("property", name);
        else tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMeta("description", copy.description);
    setMeta("og:title", copy.title, true);
    setMeta("og:description", copy.ogDescription, true);
    setMeta("og:type", "website", true);
    setMeta("og:url", "https://www.puertoricoesportleague.com/the-show", true);
    setMeta("og:image", "https://www.puertoricoesportleague.com/logo.png", true);

    let canonical = document.head.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", "https://www.puertoricoesportleague.com/the-show");

    const schemaId = "prel-show-schema";
    let schemaTag = document.getElementById(schemaId);
    if (!schemaTag) {
      schemaTag = document.createElement("script");
      schemaTag.type = "application/ld+json";
      schemaTag.id = schemaId;
      document.head.appendChild(schemaTag);
    }
    schemaTag.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "CreativeWorkSeries",
          name: "Puerto Rico Esports League: The Show",
          url: "https://www.puertoricoesportleague.com/the-show",
          description: copy.schemaDescription,
          publisher: {
            "@type": "Organization",
            name: "Puerto Rico Esports League",
            url: "https://www.puertoricoesportleague.com",
          },
        },
        {
          "@type": "VideoGallery",
          name: lang === "en" ? "The Show samples" : "Muestras de El Show",
          url: "https://www.puertoricoesportleague.com/the-show",
        },
      ],
    });
  }, [copy, lang]);

  return (
    <div className="min-h-screen bg-[#06070A] text-white">
      <SiteHeader current="/the-show" />

      <main>
        <section className="max-w-[1400px] mx-auto px-6 xl:px-8 pt-14 pb-20">
          <p className="text-xs tracking-[0.3em] uppercase text-[#CE1126]">{copy.heroEyebrow}</p>
          <h1 className="mt-4 text-[clamp(2.8rem,8vw,6.5rem)] font-black leading-[0.9] uppercase">
            {copy.heroTitle}<br />
            <span className="text-cyan-300">{copy.heroHighlight}</span>
          </h1>
          <p className="mt-6 max-w-4xl text-slate-300 text-lg leading-relaxed">{copy.heroBody}</p>

          <div className="mt-8 grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-3 max-w-[1120px] xl:max-w-[1180px]">
            {photoStrip.map((item) => (
              <article key={item.src} className="relative overflow-hidden rounded-[18px] border border-white/10 bg-[#111722] shadow-[0_14px_32px_rgba(0,0,0,0.2)]">
                <div className="aspect-[15/10]">
                  <img
                    src={item.src}
                    alt={lang === "en" ? item.altEn : item.altEs}
                    className="w-full h-full object-cover"
                    style={{ objectPosition: item.objectPosition }}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/24 via-transparent to-transparent pointer-events-none" />
              </article>
            ))}
          </div>
        </section>

        <section className="max-w-[1400px] mx-auto px-6 xl:px-8 pb-20">
          <div className="grid md:grid-cols-3 border border-white/10 bg-[#121826] rounded-[24px] overflow-hidden">
            {copy.metrics.map(([value, label]) => (
              <article key={label} className="p-6 md:p-8 border-r border-b md:border-b-0 border-white/10 last:border-r-0">
                <p className="text-3xl md:text-4xl font-black">{value}</p>
                <p className="text-[11px] uppercase tracking-[0.2em] text-slate-400 mt-2">{label}</p>
              </article>
            ))}
          </div>
          <p className="text-sm text-slate-400 mt-3 max-w-4xl">{copy.metricsNote}</p>

          <div className="mt-6 border border-white/10 bg-[linear-gradient(180deg,#101624_0%,#0b1019_100%)] px-6 py-6 md:px-8 md:py-7 rounded-[24px]">
            <div className="grid lg:grid-cols-[1.1fr_auto] gap-6 items-center">
              <div>
                <p className="text-[11px] uppercase tracking-[0.28em] text-cyan-300">{copy.partnerEyebrow}</p>
                <p className="mt-3 text-base md:text-lg text-white font-semibold leading-snug">{copy.partnerTitle}</p>
                <p className="mt-2 text-sm text-slate-400 max-w-2xl leading-relaxed">{copy.partnerBody}</p>
              </div>

              <div className="flex flex-wrap items-center gap-3 md:gap-4">
                <div className="h-[74px] w-[168px] rounded-[20px] border border-white/10 bg-white/[0.03] flex items-center justify-center px-6">
                  <img src="/wipr.png" alt="WIPR" className="max-h-9 w-auto object-contain" loading="lazy" decoding="async" />
                </div>
                <div className="h-[74px] w-[168px] rounded-[20px] border border-white/10 bg-white/[0.03] flex items-center justify-center px-6">
                  <img src="/PRTV.png" alt="PRTV+" className="max-h-10 w-auto object-contain" loading="lazy" decoding="async" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="max-w-[1400px] mx-auto px-6 xl:px-8 pb-16 grid lg:grid-cols-2 gap-8 items-start">
          <div className="border border-white/10 bg-[#111722] p-7 rounded-[24px]">
            <p className="text-xs uppercase tracking-[0.3em] text-[#CE1126]">{copy.whyEyebrow}</p>
            <h2 className="mt-3 text-3xl font-black uppercase">{copy.whyTitle}</h2>
            <p className="mt-4 text-slate-300 leading-relaxed">{copy.whyBody1}</p>
            <p className="mt-4 text-slate-300 leading-relaxed">{copy.whyBody2}</p>
          </div>

          <div className="grid gap-3">
            {copy.highlights.map((item) => (
              <article key={item.title} className="border border-white/10 bg-[#0F1220] p-6 rounded-[20px]">
                <h3 className="text-xl font-bold">{item.title}</h3>
                <p className="text-slate-300 mt-3 leading-relaxed">{item.body}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="max-w-[1600px] mx-auto px-6 xl:px-8 pb-20">
          <div className="flex items-end justify-between gap-4 mb-6">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-[#CE1126]">{copy.samplesEyebrow}</p>
              <h2 className="text-2xl md:text-3xl font-black uppercase">{copy.samplesTitle}</h2>
            </div>
            <a href="https://wipr.pr" target="_blank" rel="noopener noreferrer" className="text-cyan-300 text-sm hover:underline">
              {copy.visitWipr}
            </a>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {featuredEpisodes.map((video) => (
              <article key={video.id} className="rounded-[20px] overflow-hidden border border-white/10 bg-[#0f1420]">
                <div className="aspect-video">
                  <iframe
                    className="w-full h-full"
                    src={`https://www.youtube.com/embed/${video.id}`}
                    title={lang === "en" ? video.titleEn : video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
                <p className="text-xs md:text-sm text-slate-300 p-3">{lang === "en" ? video.titleEn : video.title}</p>
              </article>
            ))}
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}
